import { SearchPublicationItems } from '@app/entities/models/search/search-publication-items.model';

export class SearchPublicationCollection {
  page!: number;
  pageSize!: number;
  totalItems!: number;
  items!: SearchPublicationItems[];
  totalPages!: number;
}
